import { t } from 'i18next'
import { useFormContext } from 'react-hook-form'

import { Button, Label, RadioGroup, RadioGroupItem } from '@/components/ui'
import {
  StepPropostaContent,
  StepPropostaFooter,
  StepPropostaHeaderContent,
  StepPropostaHeaderTitle,
  StepPropostaRoot,
} from '@/features/proposta/layouts'
import type {
  CompradorPessoaJuridicaSchemaInput,
  CompradorPessoaJuridicaSchemaOutput,
} from '@/features/proposta/schemas/compradores/comprador-pj.schema'

type TSelecaoCompradorMenorVinculo = {
  onBack: () => void
  onNext: () => void
}

const OPTIONS_TIPO_RESPONSAVEL = [
  {
    label: t('proposta:cadastro_compradores.steps.dados_comprador_pj.opcoes_vinculo.procurador'),
    value: 'Procurador',
  },
  {
    label: t('proposta:cadastro_compradores.steps.dados_comprador_pj.opcoes_vinculo.representante'),
    value: 'Representante',
  },
] as const

export const TipoResponsavelPJ = ({ onBack, onNext }: TSelecaoCompradorMenorVinculo) => {
  const { trigger, setValue, watch } = useFormContext<
    CompradorPessoaJuridicaSchemaInput,
    unknown,
    CompradorPessoaJuridicaSchemaOutput
  >()
  const tipoResponsavel = watch('responsavel.tipo')
  const handleValidateOnNext = async () => {
    const isValid = await trigger('responsavel.tipo')
    if (!isValid) return
    onNext()
  }

  return (
    <StepPropostaRoot>
      <StepPropostaHeaderContent>
        <StepPropostaHeaderTitle>
          {t('proposta:cadastro_compradores.steps.dados_comprador_pj.responsavel_empresa')}
        </StepPropostaHeaderTitle>
      </StepPropostaHeaderContent>
      <StepPropostaContent hasBorder>
        <div className="grid pt-3">
          <RadioGroup
            className="flex flex-col gap-4"
            value={tipoResponsavel}
            onValueChange={(value: (typeof OPTIONS_TIPO_RESPONSAVEL)[0]['value']) => {
              setValue('responsavel.tipo', value)
            }}
          >
            {OPTIONS_TIPO_RESPONSAVEL.map((option) => (
              <div key={option.label} className="flex items-center gap-2 p-2">
                <RadioGroupItem value={option.value} id={option.value} />
                <Label className="font-nunito text-base" htmlFor={option.value}>
                  {option.label}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </StepPropostaContent>
      <StepPropostaFooter>
        <Button className="font-nunito h-12 w-full md:w-auto" variant="outline" onClick={onBack}>
          {t('proposta:cadastro_compradores.steps.voltar')}
        </Button>
        <Button className="font-nunito h-12 w-full md:w-27" onClick={handleValidateOnNext}>
          {t('proposta:cadastro_compradores.steps.proximo')}
        </Button>
      </StepPropostaFooter>
    </StepPropostaRoot>
  )
}
